<div [class.working]="toggle.working">

  <span class="lib-spacer"></span>

  <div #container [hidden]="toggle?.event_scheduled"></div>

  <div class="confirmation" [hidden]="!toggle?.event_scheduled">

    <header>

      <figure>
        <img [src]="data?.agent?.avatar || data?.calendlyAgent?.avatar_url || defaultAvatar">
      </figure>

      <h2>{{confirmationTitle}}</h2>
      <p class="lib-legend">{{confirmationMessage}}</p>

    </header>

    <span class="lib-spacer-fixed"></span>

    <div [hidden]="!data">

      <p>
        <strong>{{(data?.call?.startTime || data?.calendlyEvent?.start_time) | date: 'h:mm a'}}</strong><span [hidden]="!data?.agent?.display_name">&nbsp;with {{data?.agent?.display_name}}</span>
      </p>
      <p>{{(data?.call?.startTime || data?.calendlyEvent?.start_time) | date: 'EEEE, d MMMM, y'}}</p>

    </div>

    <nav class="lib-nav">
      <span class="lib-spacer"></span>
      <button class="lib-button-flat-primary" [hidden]="!doneBtn" (click)="closeCalendlyInlineWidget($event)">
        <span>{{doneBtn}}</span>
      </button>
      <span class="lib-spacer"></span>
    </nav>

  </div>

  <span class="lib-spacer"></span>

</div>
